import { mergeFragments } from "../../mergeFragments";
import base from "./base";
import strays from "./strays";
import w4Booking from "./w4_booking";
import reviews from "./reviews";
// crm-module BEGIN C3.02/C3.04 (lane F4)
import promote from "./promote";
// crm-module END

export default mergeFragments([base, strays, w4Booking, reviews,
  // crm-module BEGIN C3.02/C3.04 (lane F4)
  promote,
  // crm-module END
]);
